<form [formGroup] = "form">
  
  <div id="certmodal" style="display:none; position:fixed; z-index:1000; left:0; top:0; width:100%; height:100%; overflow:auto; background-color:rgba(0,0,0,0.75);">
    <div style="background-color: #ffffff;
    margin: 25% auto;
    padding: 2em;
    border: 1px solid #888;
    width: 80%;
    max-width: 360px;
    border-radius: 1em;">
      <p style="color: #424242;font-weight: 600;">{{certStatus.text}}</p>
      <div style="display: flex; flex-direction: row;">
          <div>
            <p>Required Credentials:</p>
            <ul>
              <li *ngFor="let cert of jobCerts">{{cert}}</li>
            </ul>
          </div>
          <div>
            <p>Employee's Credentials:</p>
            <ul>
              <li *ngFor="let ecert of empCreds">{{ecert}}</li>
            </ul>
          </div>
          
        </div>
      <button style="background: #8cc63f;
      color: #ffffff;
      width: 6em;
      border: 1px solid #ffffff;
      height: 3em;
      border-radius: 0.5em;" (click)="closeModal()">Ok</button>
    </div>
  </div>


  <div #modalContent id="maindiv">
  <div class="form-actions-sticky-div">

    <h1 *ngIf ="mode ==1" mat-dialog-title> <span style="color: #999;">Editing </span> <span style="font-size: 1em;color: #999;">{{customer_name? customer_name.trim(): ''}} - {{data.job.customer_jobtype ? data.job.customer_jobtype.trim() : ''}}</span> {{prodCustText || ''}} </h1>
    <h1 *ngIf ="mode ==2" mat-dialog-title> <span style="color: #999;">Add Job </span> <span style="font-size: 1em;color: #999;">{{customer_name? customer_name.trim(): ''}} - {{data.job.customer_jobtype ? data.job.customer_jobtype.trim() : ''}}</span> {{prodCustText || ''}}</h1>
    <div *ngIf="payhold">
      <p class="relativeButton" style="color: red;margin-left: 15px;margin-top: 15px;"> This customer has a payment hold. We cannot not put on jobs for them until this is resolved. </p>
    </div>
    <h2 *ngIf = "isAudit" style="color: #333;
    font-size: 1.5em;"> Audit Job </h2>
    <h5>{{data.job.conf_status}}</h5>

    <div style="margin-top: 20px;">
      <div style="float: right;">[Scope: {{scope}} ]</div>

      <div *ngIf="showShowAllJobs">
      <span><label>Show all jobs</label></span>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" (change)="toggleOverride()"></mat-checkbox>
        <!--<span class="slider round"></span> -->

        <span style="margin-left: 20px;"><label>First Stop</label></span>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;"  (change)="($event.checked) ? onFirstJobCheck() : null"  formControlName="firststop"></mat-checkbox>
        
        <span style="margin-left: 20px;"><label>Trip?</label></span>
        <span [matTooltip]="tripToggleTooltip" matTooltipPosition="above">
          <mat-checkbox style="padding-left: 5px; padding-right: 7px;" [checked]="form.get('istrip')?.value || convertToTrip" [disabled]="!canToggleTrip" (change)="enableTripMode()"></mat-checkbox>
        </span>


      </div>

      <div *ngIf="!showShowAllJobs">
        <p style="font-size: 12px;">Note, the scope for this subdivision does not apply to job selection.</p>
        <span style="margin-left: 20px;"><label>First Stop</label></span>
      <mat-checkbox style="padding-left: 5px; padding-right: 7px;"  (change)="($event.checked) ? onFirstJobCheck() : null"  formControlName="firststop"></mat-checkbox>

      </div>


      </div>

    <div></div>


  </div>

  <mat-tab-group (selectedTabChange)="onTabChange($event)">

    <mat-tab label="Basic Info">
      <div id="bigcontainer" fxLayout="row" fxLayout.xs = "column" style="overflow-y:auto" style="padding:10px;">

        <div id="row1" style="width:130%">

          <div *ngIf="!dropdownStatus">
            <mat-form-field style="width:90%; padding-top: 1em;">
              <mat-label>Job: {{this.customer_name}} - {{this.data.job.customer_jobtype}} </mat-label>
              <input  #custjob matInput [placeholder]="this.data.job.job_name" formControlName = "customer_job" [matAutocomplete] = "cj">
              </mat-form-field>

          <mat-autocomplete #cj = "matAutocomplete" (optionSelected) = "onSelectJob($event.option.value)" [panelWidth]="'auto'" [displayWith]="displayFunction">
              <mat-option *ngFor="let cj of (customerjob$ | async)" [value]="cj">
                <span style="font-size:14px; font-weight:200">{{ cj.job_name}}</span>
              </mat-option>
            </mat-autocomplete>
          </div>

          <div *ngIf="dropdownStatus">

            <mat-form-field>
              <mat-select formControlName="customer_job">
                <mat-option *ngFor="let job of customerJobs" [value]="job.customerjob_id">
                  {{ job.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
              <p>Drowdown!</p>

          </div>

        <mat-form-field style="width:90%" *ngIf="!isAudit">
          <mat-label>Employee: {{employee_name}}</mat-label>
          <input id="employeeInput" #technitian matInput [placeholder]="this.data.job.employee_name? this.data.job.employee_name.trim() : '' " formControlName = "technitian" [matAutocomplete] = "employeeauto" #autoTrigger="matAutocompleteTrigger">
          <button *ngIf="data.job.employee_name" matSuffix mat-icon-button aria-label="Clear" (click)="resetEmployeeName(this.data)">
            X
          </button>
        </mat-form-field>

      <mat-autocomplete #employeeauto = "matAutocomplete" (optionSelected) = "onSelectEmployee($event.option.value)" [displayWith]="displayFunctionEmployee">
          <mat-option *ngFor="let em of (employee$ | async)" [value]="em">
            <span>{{ em.employee_name}}</span>
          </mat-option>
        </mat-autocomplete>

        <div *ngIf="certStatus.text.length > 0" [style.color]="certStatus.color" style="font-size: 0.8em; margin-top: 10px;padding-bottom: 2em;">
          {{certStatus.text}}
        </div>


        <div *ngIf="timeOffShow">
          <p class="relativeButton" style="color: red;"> {{this.timeOffMessage}} </p>
        </div>


        <mat-form-field style="width:90%" *ngIf="!isAudit">
          <mat-label>Manager: {{data.job.name}}<em>({{data.job.contact_name}})</em></mat-label>
          <input  #refname matInput [placeholder]="this.data.job.name ? this.data.job.name.trim() : '' " formControlName = "contact_name" [matAutocomplete] = "custauto">
          <button *ngIf="data.job.name" matSuffix mat-icon-button aria-label="Clear" (click)="resetContactName(this.data)">
            X
          </button>
        </mat-form-field>

        <!-- Subdivision consultant (read-only), shown when the subdivision has one. -->
        <div *ngIf="!isAudit && consultantName" style="width:90%; margin: -0.5em 0 0.75em; color:#9e9e9e; font-size:0.85em;">
          Consultant: {{consultantName}}
        </div>

      <!-- we need to not show the autocomplete when not in use-->
      <mat-autocomplete #custauto = "matAutocomplete" (optionSelected) = "onSelectContact($event.option.value)" [displayWith]="displayFunction">
        <mat-option *ngFor="let contact of (contact$ | async)" [value]="contact">
          <span>{{ contact.name}}</span>
        </mat-option>
      </mat-autocomplete>

      <div matRipple [matRippleDisabled]="true" #managerphoneRipple *ngIf="!isAudit">

        <mat-form-field style="width:90%">
          <mat-label>Manager Phone #: </mat-label>
          <input matInput formControlName="contact_phone">
        </mat-form-field>
      </div>

      <div matRipple [matRippleDisabled]="true" #manageremailRipple *ngIf="!isAudit">

        <mat-form-field style="width:80%">
          <mat-label [title]="this.form.get('contact_e_mail').value">Manager Email(s): </mat-label>
          <input matInput formControlName="contact_e_mail">
        </mat-form-field>
      </div>

        <div style="display:flex; align-items:center;">
          <div matRipple [matRippleDisabled]="true" #scheduledateRipple *ngIf="!isAudit">
            <mat-form-field>
              <mat-label>Schedule Date</mat-label>
              <input (dateChange)="onSelectDate('change', $event)" matInput formControlName = 'schedule_date' [matDatepicker]="schedule_date" [matDatepickerFilter]="sundayDateFilter" disabled>
              <mat-datepicker-toggle matSuffix [for]="schedule_date" [matTooltip]="moveLocked ? MANDATORY_LOCK_MSG : ''"></mat-datepicker-toggle>
              <!-- The original `disabled="false"` was a string attribute, not a binding.
                   moveLocked is false for everyone but a non-scheduler on a mandatory job. -->
              <mat-datepicker #schedule_date [disabled]="moveLocked"></mat-datepicker>
            </mat-form-field>
            <div *ngIf="moveLocked" style="color:#d32f2f; font-size:12px; margin-top:-1em;">
              Mandatory Job &mdash; contact scheduling to move this job.
            </div>
          </div>

          <!-- Hours already booked for this location's region + product group on the selected date -->
          <div *ngIf="!isAudit" style="display:flex; align-items:center; min-height:24px; margin-left:12px;">
            <mat-spinner *ngIf="hoursLoading" diameter="18"></mat-spinner>
            <span *ngIf="!hoursLoading && hoursInfo"
                  [style.color]="hoursOverCapacity ? '#e53935' : '#8cc63f'"
                  style="font-size:13px; font-weight:600; white-space:nowrap;"
                  [title]="hoursTooltip">
              {{ hoursInfo.region }} {{ hoursInfo.category || 'All' }}: {{ hoursInfo.hours }}<span *ngIf="hoursInfo.capacity != null"> / {{ hoursInfo.capacity }}</span> hrs
            </span>
          </div>

        </div>

        <mat-form-field style="line-height: 0.9;padding-top: 1em;">
          <mat-label> Status </mat-label>
          <mat-select  formControlName = "job_status" (selectionChange)="setStatusDirty()">
            <mat-option *ngFor = "let status of availableStati" [value] = "status.value">
          {{status.viewValue}}
            </mat-option>
      </mat-select>
        </mat-form-field>

      </div>


        <!-- Fixed basis: as a content-sized flex item the column changed width with whichever fields rendered. -->
        <div id="row2" style="overflow-y:auto; flex:0 0 auto; width:340px; max-width:100%;" *ngIf="!isAudit">

          <div *ngIf="!isAudit" style="width:80%;">
            <mat-form-field style="width:100%;">
              <mat-label>Job Notes: </mat-label>
              <textarea matInput formControlName = "job_notes" (blur)="updateNotes()" rows="5"></textarea>
            </mat-form-field>
            <div style="display:flex; justify-content:flex-end;">
              <button mat-stroked-button type="button" style="white-space:nowrap;" (click)="openAddJobNote()">Add Signed Note</button>
            </div>
          </div>

          <!-- Trip only: each child task's own notes, saved on the child row with the dialog's Save. -->
          <div *ngIf="isEditTrip && selectedJobs?.length" style="width:80%;">
            <h4 style="margin: .5em 0;">Task Notes</h4>
            <mat-form-field *ngFor="let item of selectedJobs" style="width:100%;">
              <mat-label>[{{ item.customer_jobtype?.trim() }}] notes</mat-label>
              <textarea matInput [(ngModel)]="item.job_notes" [ngModelOptions]="{standalone: true}" rows="3"></textarea>
            </mat-form-field>
          </div>

              <!-- Billing fields hide (not disable) when they don't apply: non-billable job type, or PO/Invoice
                   on a trip. The controls stay in the FormGroup so saved values are kept. -->
              <mat-form-field style="width:80%" *ngIf="!isAudit && form.get('billing_note').enabled">
                <mat-label>Billing Notes: </mat-label>
                <textarea style="height: 100px;" matInput formControlName = "billing_note" (blur)="updateNotes()"></textarea>
              </mat-form-field>

              <mat-form-field style="width:80%" *ngIf="!isAudit && !form.get('istrip')?.value && form.get('po_number').enabled">
                <mat-label>PO Number: </mat-label>
                <input matInput formControlName="po_number">
              </mat-form-field>

              <mat-form-field style="width:80%" *ngIf="!isAudit && !form.get('istrip')?.value && form.get('invoice_number').enabled">
                <mat-label>Invoice: </mat-label>
                <input matInput formControlName="invoice_number">
              </mat-form-field>

              <mat-form-field style="width:80%" *ngIf="!isAudit && !form.get('istrip')?.value">
                <mat-label>Invoice Amount: </mat-label>
                <input matInput formControlName="invoice_amount">
              </mat-form-field>

              <mat-form-field style="width:80%" *ngIf="!isAudit">
                <mat-label>Estimate No. : </mat-label>
                <input matInput formControlName="estimateno">
              </mat-form-field>

        <div matRipple [matRippleDisabled]="true" #estimatedtimeRipple>

          <mat-form-field style="width:90%">
            <label>Estimated Time (hours): </label>
            <input matInput formControlName="estimatedtime" style="margin-left: 30px;">
          </mat-form-field>
        </div>

          <!-- Margin collapses when the modeler date follows, so the two dates read as a pair. -->
          <div matRipple [matRippleDisabled]="true" #flexstartdateRipple [style.margin-bottom.px]="showModelerDueDate ? 0 : 20" *ngIf="!isAudit">
            <mat-label style="color:black; margin-right:10px;">Due Date (optional)</mat-label>

            <mat-form-field [attr.disabled]="isManualJobtype ? null : 'true'">
              <input [style.color]="isManualJobtype ? 'black' : '#9f9f9f'" (dateChange)="onSelectFlexDate('change', $event)" matInput formControlName = 'flex_start_date' [matDatepicker]="flex_start_date">
              <mat-datepicker-toggle matSuffix [for]="flex_start_date"></mat-datepicker-toggle>
              <mat-datepicker #flex_start_date [disabled]="!isManualJobtype"></mat-datepicker>
            </mat-form-field>
          </div>

          <!-- Read-only. The control is disabled in the FormGroup, which is what keeps it
               out of form.value and therefore out of the save payload. Do not enable it. -->
          <div style="margin-bottom:20px;" *ngIf="showModelerDueDate">
            <mat-label style="color:black; margin-right:10px;">Modeler Due Date</mat-label>

            <mat-form-field [attr.disabled]="'true'">
              <input style="color:#9f9f9f;" matInput formControlName="modeler_duedate" [matDatepicker]="modeler_duedate">
              <mat-datepicker #modeler_duedate disabled="true"></mat-datepicker>
            </mat-form-field>
          </div>

            </div>




      </div>

      <div id="main-container-auditfields">
      <div *ngIf="isAudit" id="container-audfields-split" style="display:flex;">


        <div id="left-column" style="width: 50%;
        padding: 20px;">

          <div>
            <h3 style="font-size: 1.25em;color:#333;">Overall Audit </h3>
          </div>

          <div id="audname" style="margin-top: 15px; margin-bottom: 30px;" *ngIf="isAudit">

            <div>
            <label for="auditorname">
              <h3 style="display: block;
              font-size: 0.75em;
              margin-bottom: 8px;
              color: #333;">Auditor</h3>
            </label>
          </div>
            <mat-form-field style="line-height: 0.9;">
              <mat-select formControlName = 'auditorname'>
                <mat-option value="Beth Ainsworth">Beth Ainsworth</mat-option>
                <mat-option value="David Bess">David Bess</mat-option>
                <mat-option value="Diana Gochez">Diana Gochez</mat-option>
                <mat-option value="Dylan Moles">Dylan Moles</mat-option>
                <mat-option value="Elena Arana">Elena Arana</mat-option>
                <mat-option value="Gary Vyner">Gary Vyner</mat-option>
                <mat-option value="Greg Hite">Greg Hite</mat-option>
                <mat-option value="Hunter Cook">Hunter Cook</mat-option>
                <mat-option value="Jacob Buckner">Jacob Buckner</mat-option>
                <mat-option value="Jeremy Price">Jeremy Price</mat-option>
                <mat-option value="Jim Forgays">Jim Forgays</mat-option>
                <mat-option value="Misty Kilgore">Misty Kilgore</mat-option>
                <mat-option value="Monte Mickys">Monte Mickys</mat-option>
                <mat-option value="Neyle Steadman">Neyle Steadman</mat-option>
                <mat-option value="Woody Woodward">Woody Woodward</mat-option>
                <mat-option value="Zach Sumner">Zach Sumner</mat-option>
              </mat-select>
            </mat-form-field>
            </div>


            <div *ngIf="isAudit" id="regions">
              <mat-form-field style="line-height: 0.9;">
                <mat-label> Region </mat-label>
                <mat-select  formControlName = "region">
                  <mat-option *ngFor = "let region of regions" [value] = "region.value">
                    {{region.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              </div>

              <div id="ovlscore" *ngIf="isAudit">
                <mat-form-field>
                  <mat-label>Overall Score</mat-label>
                  <input matInput formControlName = 'ovlscore' type="number" min="0" max="999">
                </mat-form-field>
              </div>


              <div id="audinspdate" *ngIf="isAudit" style="padding-top: 2em;">
                <p>
                  <mat-form-field>
                    <mat-label>Inspection Date</mat-label>
                    <input (dateChange)="inspectionDateChange()" matInput formControlName = 'audinspdate' [matDatepicker]="audinspdate" disabled>
                    <mat-datepicker-toggle matSuffix [for]="audinspdate"></mat-datepicker-toggle>
                    <mat-datepicker #audinspdate disabled="false"></mat-datepicker>
                  </mat-form-field>
                </p>
              </div>

        </div>

        <div id="right-column" style="width: 50%;
        padding: 20px;">


          <div id="constage" style="margin-bottom: 30px; color:#333 !important;" *ngIf="isAudit">
            <mat-label style="margin-right: 35px;
            font-size: 20px;
            font-weight: 500;
            display:flex;">Energy Program</mat-label>
            <mat-radio-group formControlName = 'nrgprogram' style="font-size: 20px;
            line-height: 2;" >
              <mat-radio-button style="margin-right:15px;" value="ES">ES</mat-radio-button>
              <mat-radio-button style="margin-right:15px;" value="ES+HERO">ES+HERO</mat-radio-button>
              <mat-radio-button style="margin-right:15px;" value="HERS">HERS</mat-radio-button>
              <mat-radio-button style="margin-right:15px;" value="HERS+HERO">HERS+HERO</mat-radio-button>
            </mat-radio-group>
          </div>


          <div id="constage" style="margin-bottom: 30px; color:#333 !important;" *ngIf="isAudit">
            <mat-label style="margin-right: 35px;
            font-size: 20px;
            font-weight: 500;
            display:flex;">Construction Stage</mat-label>
            <mat-radio-group formControlName = 'constage' style="font-size: 20px;
            line-height: 2;" >
              <mat-radio-button style="margin-right:15px;" value="File">File</mat-radio-button>
              <mat-radio-button style="margin-right:15px;" value="Rough">Rough</mat-radio-button>
              <mat-radio-button style="margin-right:15px;" value="Final">Final</mat-radio-button>
              <mat-radio-button style="margin-right:15px;" value="QI">QI</mat-radio-button>
            </mat-radio-group>
          </div>

          <div id='audtype' style="margin-bottom: 30px;color:#333 !important;" *ngIf="isAudit">
            <mat-label style="margin-right: 35px;
            font-size: 20px;
            font-weight: 500;
            display:flex;">Type</mat-label>
            <mat-radio-group formControlName = 'audtype' style="font-size: 20px;
            line-height: 2;">
              <mat-radio-button style="margin-right:15px;" value="Blind">Blind</mat-radio-button>
              <mat-radio-button style="margin-right:15px;" value="Ride along">Ride along</mat-radio-button>
            </mat-radio-group>
          </div>

        </div>

      </div>

      <div id="container-aud-fields-bottom" style="display:flex; flex-direction: column;" *ngIf="isAudit">

        <div id="audnotes" *ngIf="isAudit" style="width:100%">
          <!-- Custom label with your own styling -->
          <label for="auditNotes">
            <h3 style="    display: block;
            font-size: 1.25em;
            margin-bottom: 8px;
            color: #333;">Overall Location Audit Notes</h3>
            <details>
              <summary style="color: #424242;font-weight: bold;font-size: 0.85em;padding-bottom: 2em;">
                IMPORTANT - Type employee's initials followed by a dash when recording findings. (Click for valid examples)
              </summary>
              <p style="font-style: italic;
              padding-left: 2em;
              color: grey;">AB - (enter findings for AB here)</p>
            </details>
            

          </label>
        
          <!-- Form field without the default label -->
          <mat-form-field style="width: 100%;" appearance="outline">
            <textarea
              id="auditNotes"
              matInput
              formControlName="audnotes"
              style="height:200px; color: #333;background: white;
              padding: 1em;"
            ></textarea>
          </mat-form-field>
        </div>

        <div id="individualAuditSection">
          <div>
            <h3 style="font-size: 1.25em;color:#333">Individual Audits </h3>
          </div>

          <div id="addIndividualAudits" style="padding: 20px; border: 1px solid #ccc; border-radius: 8px; margin-bottom: 20px; background-color: #f9f9f9;">
            <!--<h3 style="text-align: center; color: #333; margin-bottom: 20px;font-size: 1em;">Add Individual Audits</h3> -->
          
            <!-- List of Added Entries -->
            <div *ngIf="mode == 1 && isAudit && previousIndivAudits.length > 0;">
            <div *ngFor="let audit of previousIndivAudits; let i = index" style="margin-bottom: 15px;">
              <div class="indivAuditDiv" style="display: flex; justify-content: space-between; align-items: center; background-color: #e8f5e936; padding: 10px; border-radius: 4px;">
                <div>
                  <p style="margin: 0; font-weight: bold;letter-spacing: 0.1em;">Employee: {{ audit.employee_name }}</p>
                  <p style="margin: 0;">Score: {{ audit.score }}</p>
                </div>
                <button mat-icon-button color="warn" (click)="removeAudit(i, true)" aria-label="Remove audit">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>

            <div *ngFor="let audit of individualAudits; let i = index" style="margin-bottom: 15px;">
              <div class="indivAuditDiv" style="display: flex; justify-content: space-between; align-items: center; background-color: #e8f5e9; padding: 10px; border-radius: 4px;">
                <div>
                  <p style="margin: 0; font-weight: bold;letter-spacing: 0.1em;">Employee: {{ audit.employee_name }}</p>
                  <p style="margin: 0;">Score: {{ audit.score }}</p>
                </div>
                <button mat-icon-button color="warn" (click)="removeAudit(i)" aria-label="Remove audit">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>



          
            <!-- Add New Entry Form -->
            <div style="margin-bottom: 20px;">

              <mat-form-field style="width:100%; padding-top:1em;">
                <mat-label>Employee: {{newAudit.employee}}</mat-label>
                <input id="employeeInput" matInput [placeholder]="'Select an employee'" [matAutocomplete]="indivauditemp" formControlName = "indivEmployee"/>
              </mat-form-field>
              
              <mat-autocomplete #indivauditemp="matAutocomplete" [displayWith]="displayFunctionIndivEmployee" (optionSelected) = "onSelectIndivEmployee($event.option.value)">
                <mat-option *ngFor="let em of (indivemployee$ | async)" [value]="em">
                  <span>{{ em.employee_name }}</span>
                </mat-option>
              </mat-autocomplete>
          
              <mat-form-field style="width:100%">
                <mat-label>Score</mat-label>
                <input matInput type="number" min="0" max="999" formControlName="indivScore" (input)="updateScore()">
              </mat-form-field>
          
              <button mat-raised-button color="primary" style="width: 100%;
              margin-top: 10px;
              font-weight: bold;
              letter-spacing: 0.1em;" (click)="addIndividualAudit()">Add Individual</button>
            </div>
          </div>
        </div>




      </div>

    </div>

    </mat-tab>

    <mat-tab label="Tags">

      <!-- The chip input control -->
      
      <div style="display: flex;
      width: 90%;
      height: 200px;
      margin-top: 30px;
      align-content: flex-start;
      flex-wrap: wrap;
      justify-content: space-evenly;">
      <mat-form-field style="width:85%;">
        <mat-chip-list #chipList>
          <!-- 'Mandatory Job' (tag 57) is not removable by anyone outside scheduling. -->
          <mat-chip *ngFor="let tag of inputTags" [selectable]="true"
                    [removable]="!(tag.id === MANDATORY_JOB_TAG_ID && !isScheduler)" (removed)="removeTag(tag)"
                    [ngStyle]="isRedTag(tag) ? {'background-color': '#d32f2f', 'color': '#ffffff'} : {}">
            {{tag.displayname}}
            <mat-icon *ngIf="!(tag.id === MANDATORY_JOB_TAG_ID && !isScheduler)" matChipRemove
                      [ngStyle]="isRedTag(tag) ? {'color': '#ffffff'} : {}">cancel</mat-icon>
          </mat-chip>
          <input placeholder="Add tag..."
                 [matAutocomplete]="auto"
                 [matChipInputFor]="chipList"
                 [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                 (matChipInputTokenEnd)="addTag($event)"
                 (keyup.enter)="onEnter(auto)"
                 formControlName="tagControl">
        </mat-chip-list>
        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTag($event, $event.option.value)">
          <mat-option *ngFor="let tag of filteredTags | async" [value]="tag">
            {{tag.displayname}}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>




    </div>

    <!-- MF / SF / GPS tag-type filter. None ticked = show all. -->
    <div style="display:flex; gap:1em; margin-bottom:0.5em; align-items:center;">
      <span style="color:#757575; font-size:0.9em;">Show:</span>
      <mat-checkbox *ngFor="let t of tagService.TAG_TYPES"
                    [checked]="tagTypeFilter.includes(t)"
                    (change)="toggleTagType(t)">{{t}}</mat-checkbox>
    </div>

    <div style="max-height: 200px;">
      <mat-chip-list>
        <mat-chip *ngFor="let tag of visibleTags" (click)="addTag($event, tag)" matTooltip="{{tag.description}}"
                  [ngStyle]="isRedTag(tag) ? {'background-color': '#d32f2f', 'color': '#ffffff'} : {}">{{tag.displayname}}</mat-chip>
      </mat-chip-list>

        </div>

        <!--
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick()" [class.relativeButton]="!isAudit" style="border: 1px solid black;">Close</button>
  
      <div *ngIf="!payhold || mode == EDITING_MODE">
        <ng-container [ngSwitch]="mode">
          <button *ngSwitchCase="1" mat-button (click)="saveClick(2)" cdkFocusInitial [class.relativeButton]="!isAudit">
            {{ isAudit ? 'Save Audit' : 'Save' }}
          </button>
          <button *ngSwitchCase="2" mat-button (click)="saveClick(1)" cdkFocusInitial [class.relativeButton]="!isAudit">
            {{ isAudit ? 'Add Audit' : 'Add' }}
          </button>
        </ng-container>
      </div>
  
      <div id="sendemail" *ngIf="isAudit">
        <button (click)="sendAuditEmail()" style="    margin-right: 30px;">Send Audit Email</button>
      </div>
  
      <div id="audreported" class = "formitem-section" style="padding-right:20px" *ngIf="isAudit">
        <mat-label style="white-space: nowrap;">Audit Reported?  </mat-label>
        <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "audreported"></mat-checkbox>
      </div>
  
  
      <div *ngIf="payhold">
        <button class="relativeButton" style="color: #f8f9fa; background: red;" mat-button  disabled (click)="payhold = false" [mat-dialog-close]="data" cdkFocusInitial>! Payment Hold</button>
      </div>
      <div *ngIf="payhold">
        <p class="relativeButton" style="color: red;margin-left: 15px;margin-top: 15px;"> This customer has a payment hold. We cannot not put on jobs for them until this is resolved. </p>
      </div>
  
      <div *ngIf="inheritedTagsSubdivision && mode == 2">
        <p style="color: #75BD4E ;margin-left: 15px;margin-top: 15px;"> This job has inherited tags from the subdivision. Navigate to the 'Tags' tab and remove un-necessary tags. </p>
      </div>
  
      <div *ngIf="inheritedCustomerJobsTags">
        <p style="color: #75BD4E ;margin-left: 15px;margin-top: 15px;"> This job has inherited tags from the customer job. Navigate to the 'Tags' tab and remove un-necessary tags. </p>
      </div>
  
  
    </div>
-->

    </mat-tab>

    <mat-tab label="Additional Photos" *ngIf="isAudit">
      <div style="display: flex; flex-direction: column; gap: 15px; margin-top: 20px; padding:2em;">
    
        <!-- Photo Upload Input and Caption -->
          <!--<input type="file" (change)="onPhotoSelected($event)" accept="image/*" /> -->

          <div style="display: flex;
          justify-content: space-between;
          align-items: flex-end;">
            <div style="position: relative;">
              <!-- Hidden file input -->
              <input type="file" (change)="onPhotoSelected($event)" accept="image/*" style="display: none;" id="fileInput" />
            
              <!-- Custom label acting as button -->
              <label for="fileInput" class="custom-file-label">
                <i class="fas fa-camera" style="background: #69b645;
                color: white;
                border: 0;
                padding: 0.5em;
                /* width: 120px; */
                border-radius: 0.75em;
                font-size: 1em;
                margin-bottom: 4em;
                cursor: pointer;
                height: 3em;
                align-content: center;">  Take Photo
                  
                </i><!-- FontAwesome icon here -->
              </label>
            </div>

            <div *ngIf="previewUrl" style="margin: 10px 0;">
              <img [src]="previewUrl" alt="Preview" style="max-width: 200px; max-height: 200px;" />
            </div>

            <div *ngIf="!previewUrl || previewUrl == '' " style="    margin: 10px 0px;
            font-size: 1.25em;
            color: #4f4f4f;
            width: 50%;
            margin-left: 4em;">
              <p>Take a photo, add a caption, and click 'Add' to send additional photos. </p>
            </div>


          </div>
    
        <mat-form-field style="width: 100%;">
          <mat-label style="color: #959595 !important;
          font-size: 1.5em;
          padding-left: 0.5em;">Caption</mat-label>
          <textarea class = "audit" style="background: white;
          border-radius: 1em;
          color: #4f4f4f;
          padding: 1em;
          font-size: 1.5em;" matInput formControlName="newCaption"></textarea>
        </mat-form-field>
    
        <!-- Add Button -->
        <button mat-raised-button color="primary" (click)="addPhoto()">Add</button>
    
        <!-- Display Photos in Table -->
        <div *ngIf="photoTable.length > 0">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" style="margin-top: 20px; width: 100%; margin-bottom:4em;">
    
          <!-- Photo Column -->
          <ng-container matColumnDef="photo">
            <th mat-header-cell *matHeaderCellDef> Photo </th>
            <td mat-cell *matCellDef="let element">
              <img [src]="element.photo" alt="Photo" width="100" />
            </td>
          </ng-container>
    
          <!-- Caption Column -->
          <ng-container matColumnDef="caption">
            <th mat-header-cell *matHeaderCellDef> Caption </th>
            <td mat-cell *matCellDef="let element"> {{element.caption}} </td>
          </ng-container>
    
          <!-- Delete Button Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef> Actions </th>
            <td mat-cell *matCellDef="let element; let i = index">
              <button mat-icon-button (click)="removePhoto(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </td>
          </ng-container>
    
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    
        </table>
        </div>

        <div style="margin-top: 20px;">
          <button mat-raised-button color="primary" (click)="savePhotos()">Save</button>
        </div>

      </div>
    </mat-tab>
    <mat-tab label="Trip Details" *ngIf="tripMode || isEditTrip">
      <div id="tripOptions" class="trip-panes" style="padding: 20px;">

        <div class="trip-pane">
          <!-- Available Jobs Section -->
          <div class="section-header">
            <h3>Available Tasks</h3>
            <mat-divider></mat-divider>
          </div>

          <div class="jobs-container" *ngIf="availableJobs?.length > 0; else noJobs">
            <mat-card *ngFor="let item of availableJobs" class="job-card">
              <mat-card-content>
                <div class="job-info">
                  <div class="job-details">
                    <strong>{{item.customer_jobtype.trim()}}</strong>
                    <span class="job-date">{{ formatDateOnly(item.schedule_date) }}</span>
                    <span *ngIf="item.job_status" class="job-status" style="display:inline-block; margin-top:4px; padding:2px 8px; border-radius:12px; font-size:11px; background:#eeeeee; color:#424242;">{{ item.job_status.trim() }}</span>
                  </div>
                  <button mat-raised-button color="primary"
                          (click)="addJobToTrip(item)"
                          class="add-btn">
                    <mat-icon>add</mat-icon>
                    Add
                  </button>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <ng-template #noJobs>
            <p class="no-items">No available tasks to add</p>
          </ng-template>
        </div>

        <div class="trip-pane">
          <!-- Selected Jobs Section -->
          <div class="section-header">
            <h3>Selected Tasks for Trip</h3>
            <mat-divider></mat-divider>
          </div>

          <div class="selected-container" *ngIf="selectedJobs?.length > 0; else noSelected">
            <mat-card *ngFor="let item of selectedJobs; let i = index" class="job-card selected">
              <mat-card-content>
                <div class="job-info">
                  <div class="job-details">
                    <strong>{{item.customer_jobtype.trim()}}
                      <span *ngIf="i === 0" style="background: #424242; color: white; padding: 2px 8px; border-radius: 12px; font-size: 11px; margin-left: 8px;">Primary</span>
                    </strong>
                    <span class="job-date">{{ formatDateOnly(item.schedule_date) }}</span>
                    <span *ngIf="item.job_status" class="job-status" style="display:inline-block; margin-top:4px; padding:2px 8px; border-radius:12px; font-size:11px; background:#eeeeee; color:#424242;">{{ item.job_status.trim() }}</span>
                  </div>
                  <div>
                    <!-- Static indicator on the current primary — green star, matches the
                         color the "make primary" action uses on every other row. -->
                    <button *ngIf="i === 0" mat-icon-button disableRipple
                            matTooltip="Primary task"
                            style="color: #8cc63f; cursor: default;">
                      <mat-icon>star</mat-icon>
                    </button>
                    <!-- Non-primary rows: grey star = "click to make this one primary". -->
                    <button *ngIf="i !== 0 && !convertToTrip" mat-icon-button
                            (click)="makeJobPrimary(i)"
                            matTooltip="Make primary"
                            style="color: #9e9e9e;">
                      <mat-icon>star</mat-icon>
                    </button>
                    <button *ngIf="!(convertToTrip && i === 0)" mat-icon-button color="warn"
                            (click)="removeJobFromTrip(i)"
                            matTooltip="Remove from trip">
                      <mat-icon>remove_circle</mat-icon>
                    </button>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>

          <ng-template #noSelected>
            <p class="no-items">No jobs selected yet</p>
          </ng-template>
        </div>

      </div>
    </mat-tab>


  </mat-tab-group>


  <div *ngIf="!modalActive" mat-dialog-actions   [ngStyle]="activeTabIndex === 0 && !isAudit ? {'position': 'relative', 'bottom': '11.5em', 'width': '40%'} : {}">
    <button mat-button (click)="onNoClick()" [class.relativeButton]="!isAudit" style="border: 1px solid black;">Close</button>

    <div *ngIf="!payhold || mode == EDITING_MODE">
      <ng-container [ngSwitch]="mode">
        <button *ngSwitchCase="1" mat-button (click)="saveClick(2)" cdkFocusInitial [class.relativeButton]="!isAudit">
          {{ isAudit ? 'Save Audit' : 'Save' }}
        </button>
        <button *ngSwitchCase="2" mat-button (click)="saveClick(1)" cdkFocusInitial [class.relativeButton]="!isAudit">
          {{ isAudit ? 'Add Audit' : 'Add' }}
        </button>
      </ng-container>
    </div>

    <div id="sendemail" *ngIf="isAudit">
      <button (click)="sendAuditEmail()" style="    margin-right: 30px;">Send Audit Email</button>
    </div>

    <div id="audreported" class = "formitem-section" style="padding-right:20px" *ngIf="isAudit">
      <mat-label style="white-space: nowrap;">Audit Reported?  </mat-label>
      <mat-checkbox style="padding-left: 5px; padding-right: 7px;" formControlName = "audreported"></mat-checkbox>
    </div>



    <div *ngIf="inheritedTagsSubdivision && mode == 2">
      <p style="color: #75BD4E ;margin-left: 15px;margin-top: 15px;"> This job has inherited tags from the subdivision. Navigate to the 'Tags' tab and remove un-necessary tags. </p>
    </div>

  </div>





  <div>
    <div *ngIf="timeOffShow">
      <p class="relativeButton" style="color: red;margin-left: 15px;margin-top: 3em;"> {{this.timeOffMessage}} </p>
    </div>
  </div>

</div>
  </form>
